export let PopupContentType = /*#__PURE__*/function (PopupContentType) {
  PopupContentType["AcquisitionNewsletter"] = "acquisition-newsletter";
  PopupContentType["Campaign"] = "campaign";
  PopupContentType["MyNewsCompletion"] = "my-news-completion";
  PopupContentType["TopicPackageFollow"] = "topic-package-follow";
  PopupContentType["WhyRegister"] = "why-register";
  return PopupContentType;
}({});